import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials, Testimonial } from '../data/content';
function Card({
  t
}: {
  t: Testimonial;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-cobalt/20 bg-white p-6 shadow-sm shadow-cobalt/5" data-id="element-192" data-mp="3fxb40lzxjwdr">
      <p className="flex-1 text-sm leading-relaxed text-ink/80" data-id="element-193" data-mp="36zilza2tqamo">«&nbsp;{t.text}&nbsp;»</p>
      <div className="mt-6 flex items-center gap-3" data-id="element-194" data-mp="32061gvzfdfn9">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cobalt text-sm font-bold text-white" data-id="element-195" data-mp="31ybgxis2fpjp">
          {t.initials}
        </span>
        <div data-id="element-196" data-mp="2s2i7475qea5m">
          <p className="text-sm font-bold text-ink" data-id="element-197" data-mp="2s3097kf2rilg">{t.name}</p>
          <p className="text-xs text-ink/60" data-id="element-198" data-mp="v96n88kr2bno">{t.role}</p>
        </div>
      </div>
    </article>;
}
export function Testimonials() {
  const topTestimonials = testimonials.slice(0, 3);
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: number) => {
    setIndex(prev => (prev + dir + topTestimonials.length) % topTestimonials.length);
  }, [topTestimonials.length]);
  return <section className="w-full bg-white px-5 py-6 sm:py-12" data-id="element-199" data-mp="78tv338xapyf">
      <div className="mx-auto max-w-5xl" data-id="element-200" data-mp="c6vejpa9graf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-201" data-mp="c7wry0er1pvb">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-202" data-mp="zwfus0f15ag0">
            Ce qu’en disent des enseignants de chimie
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-203" data-mp="14ur4mb5brky8">
            Des supports plus visuels, mieux organisés et immédiatement utilisables changent surtout
            une chose : le temps passé à préparer.
          </p>
        </div>

        <div className="mt-6 hidden gap-6 sm:mt-10 md:grid md:grid-cols-3" data-id="element-204" data-mp="1iusay64czkl3">
          {topTestimonials.map((t, i) => <Card key={i} t={t} data-id="element-205" data-mp="1nmses9njuxmy" data-mpi={i} />)}
        </div>

        <div className="mt-8 md:hidden" data-id="element-206" data-mp="1xhqxpns9tqth">
          <div className="relative overflow-hidden" data-id="element-207" data-mp="1xgpn1kf636ca">
            <AnimatePresence mode="wait" data-id="element-208" data-mp="1sj5urglmwt1c">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-209" data-mp="1sk7hiic0j3yw">
                <Card t={topTestimonials[index]} data-id="element-210" data-mp="1ek6i77bec4lj" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex items-center justify-between" data-id="element-211" data-mp="19qvaz52o9lt3">
            <button type="button" onClick={() => go(-1)} aria-label="Témoignage précédent" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors duration-150 hover:bg-cobalt/10" data-id="element-212" data-mp="14sk0qt8gt9ac">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-213" data-mp="quvd5dn0jo1l" />
            </button>

            <div className="flex gap-2" data-id="element-214" data-mp="32g4a38wdqmo9">
              {topTestimonials.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Aller au témoignage ${i + 1}`} className={`h-2 rounded-full transition-[width,background-color] duration-200 ${i === index ? 'w-6 bg-cobalt' : 'w-2 bg-cobalt/30'}`} data-id="element-215" data-mp="37expx7z52prl" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Témoignage suivant" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors duration-150 hover:bg-cobalt/10" data-id="element-216" data-mp="2opr256jhn7yx">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-217" data-mp="20y3se1ecydjv" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}